import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { ApiService } from '../../../../../utility/api.service'
import { ToastCtl } from '../../../../components/custom/toast/ToastCtl'

export const fetchDocuments = createAsyncThunk('documents/fetchAll', async () => {
    const state = JSON.parse(localStorage.getItem('state'))
    if (state?.auth?.role === 'admin') {
        return { documents: [] }
    }

    const response = await ApiService.get(`${process.env.REACT_APP_ASSETENERGY_APP_API}/assetapp/my-document-list`)
    return { documents: response.data.documents }
})

export const fetchDocument = createAsyncThunk('document/fetch', async ({ id }) => {
    const response = await ApiService.get(`${process.env.REACT_APP_ASSETENERGY_APP_API}/assetapp/document_data/${id}`)
    return { document: response.data.documents }
})

export const uploadDocument = createAsyncThunk('document/upload', async ({ payload }, { rejectWithValue }) => {
    const response = await ApiService.post(`${process.env.REACT_APP_ASSETENERGY_APP_API}/assetapp/documents/upload`, payload)
    if (!response.success) {
        return rejectWithValue(response.exception)
    }

    return { document: response.data.document }
})

export const deleteDocument = createAsyncThunk('document/delete', async ({ id }, { rejectWithValue }) => {
    const response = await ApiService.delete(`${process.env.REACT_APP_ASSETENERGY_APP_API}/assetapp/document/${id}`)
    if (!response.success) {
        return rejectWithValue(response.exception)
    }

    return { success: response.success }
})

export const fetchFile = createAsyncThunk('file/fetch', async ({ id }) => {
    const response = await ApiService.get(`${process.env.REACT_APP_ASSETENERGY_APP_API}/assetapp/download/${id}`, { responseType: 'arraybuffer', responseEncoding: 'binary' })
    return { document: response.data }
})

const initialState = {
    documents: null,
    selectedDocument: null,
    selectedFile: null,
    loading: false,
    submitting: false,
    error: null
}

const documentSlice = createSlice({
    name: 'documents',
    initialState,
    reducers: {
        // standard reducer logic, with auto-generated action types per reducer
    },
    extraReducers: {
        [fetchDocuments.pending]: (state) => {
            state.loading = true
        },
        [fetchDocuments.fulfilled]: (state, { payload }) => {
            state.documents = payload.documents
            state.loading = false
        },
        [fetchDocuments.rejected]: (state, action) => {
            state.loading = false
            state.error = action
        },

        [fetchDocument.pending]: (state) => {
            state.loading = true
        },
        [fetchDocument.fulfilled]: (state, { payload }) => {
            state.selectedDocument = payload.document
            state.loading = false
        },
        [fetchDocument.rejected]: (state, action) => {
            state.loading = false
            state.error = action
        },

        [uploadDocument.pending]: (state) => {
            state.submitting = true
        },
        [uploadDocument.fulfilled]: (state, { payload }) => {
            state.selectedDocument = payload.document
            state.submitting = false

            ToastCtl.success('Dokument wurde erfolgreich gespeichert')
        },
        [uploadDocument.rejected]: (state, action) => {
            state.submitting = false
            // NO error state because we show toast directly

            ToastCtl.error('Dokument konnte nicht gespeichert werden')
        },

        [deleteDocument.pending]: (state) => {
            state.submitting = true
        },
        [deleteDocument.fulfilled]: (state) => {
            state.selectedDocument = null
            state.submitting = false

            ToastCtl.success('Dokument wurde erfolgreich gelöscht')
        },
        [deleteDocument.rejected]: (state, action) => {
            state.submitting = false
            // NO error state because we show toast directly

            ToastCtl.error('Dokument konnte nicht gelöscht werden')
        },

        [fetchFile.pending]: (state) => {
            state.loading = true
        },
        [fetchFile.fulfilled]: (state, { payload }) => {
            state.selectedFile = payload.document
            state.loading = false
        },
        [fetchFile.rejected]: (state, action) => {
            state.loading = false
            state.error = action
        }
    }
})

export default documentSlice.reducer